const reducers = {
  get: (state: any, action: any) => {
    state.data = action.payload;
  },
};

export default reducers;
